// iter45ap 4b-ii — deriveCheckoutToast
// Pure helper: after a successful checkout callback (Stripe/Paddle/PayPal
// return path) return the toast string. Uses `.id`-shaped discriminator
// so no drift with pickPackageIcon.
//
// Caller shape: { pkgId, credits, lang } — extracted at the call site from
// PACKAGES[i].id and PACKAGES[i].credits; lang is the on-screen language.

const NB = "\u00a0";

// "{n} report credit(s)" — French takes the singular for 0 and 1, with U+00A0 after the number.
export const creditsLabel = (n, lang = "en") => {
  const k = Number(n) || 0;
  if (lang === "fr") return k <= 1 ? `${k}${NB}crédit de rapport` : `${k}${NB}crédits de rapport`;
  return `${k} report credit${k === 1 ? "" : "s"}`;
};

export function deriveCheckoutToast({ pkgId, credits, lang = "en" }) {
  const fr = lang === "fr";
  if (pkgId === "single_report") return fr ? "Rapport débloqué" : "Report unlocked";
  if (
    (pkgId || "").startsWith("credit_bundle_") ||
    (pkgId || "").startsWith("custom_bundle_")
  ) {
    const n = Number(credits) || 0;
    if (fr) return `${creditsLabel(n, "fr")} ${n <= 1 ? "ajouté" : "ajoutés"} à votre portefeuille`;
    return `${n} report credits added to your wallet`;
  }
  return fr ? "Paiement reçu" : "Payment received";
}

export const unlockedToast = (remaining, lang = "en") => (lang === "fr"
  ? `Rapport débloqué · ${creditsLabel(remaining, "fr")} ${remaining <= 1 ? "restant" : "restants"}`
  : `Report unlocked · ${creditsLabel(remaining, "en")} remaining`);
